"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicriBodyError = exports.MicriError = void 0;
const bytes_1 = __importDefault(require("bytes"));
class MicriError extends Error {
    constructor(statusCode, code, message, originalError) {
        super(message);
        this.statusCode = statusCode;
        this.code = code;
        this.originalError = originalError || null;
    }
}
exports.MicriError = MicriError;
class MicriBodyError extends MicriError {
    constructor(err, limit) {
        let statusCode = 400;
        let code = 'invalid_body';
        let message = 'Invalid body';
        if (err.type === 'entity.too.large') {
            statusCode = 413;
            code = 'request_entity_too_large';
            message = `Body exceeded ${typeof limit === 'string' ? limit : (0, bytes_1.default)(limit)} limit`;
        }
        super(statusCode, code, message, err);
    }
}
exports.MicriBodyError = MicriBodyError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZmlsZTovLy9ob21lL2hicC9yZXBvcy9taWNyaS9zcmMvZXJyb3JzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUNBLGtEQUEwQjtBQUcxQixNQUFhLFVBQVcsU0FBUSxLQUFLO0lBS3BDLFlBQVksVUFBa0IsRUFBRSxJQUFZLEVBQUUsT0FBZSxFQUFFLGFBQXFCO1FBQ25GLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQztRQUVmLElBQUksQ0FBQyxVQUFVLEdBQUcsVUFBVSxDQUFDO1FBQzdCLElBQUksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFDO1FBQ2pCLElBQUksQ0FBQyxhQUFhLEdBQUcsYUFBYSxJQUFJLElBQUksQ0FBQztJQUM1QyxDQUFDO0NBQ0Q7QUFaRCxnQ0FZQztBQUVELE1BQWEsY0FBZSxTQUFRLFVBQVU7SUFDN0MsWUFBWSxHQUFpQixFQUFFLEtBQXNCO1FBQ3BELElBQUksVUFBVSxHQUFHLEdBQUcsQ0FBQztRQUNyQixJQUFJLElBQUksR0FBRyxjQUFjLENBQUM7UUFDMUIsSUFBSSxPQUFPLEdBQUcsY0FBYyxDQUFDO1FBRTdCLElBQUksR0FBRyxDQUFDLElBQUksS0FBSyxrQkFBa0IsRUFBRTtZQUNwQyxVQUFVLEdBQUcsR0FBRyxDQUFDO1lBQ2pCLElBQUksR0FBRywwQkFBMEIsQ0FBQztZQUNsQyxPQUFPLEdBQUcsaUJBQWlCLE9BQU8sS0FBSyxLQUFLLFFBQVEsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxJQUFBLGVBQUssRUFBQyxLQUFLLENBQUMsUUFBUSxDQUFDO1NBQ3BGO1FBRUQsS0FBSyxDQUFDLFVBQVUsRUFBRSxJQUFJLEVBQUUsT0FBTyxFQUFFLEdBQUcsQ0FBQyxDQUFDO0lBQ3ZDLENBQUM7Q0FDRDtBQWRELHdDQWNDIn0=